import React from "react";
import { Box } from "@mui/material";
import { faUserTie } from "@fortawesome/free-solid-svg-icons";
import TpUsersByType from "./TpUsersByType";
import CoordinatorBulkUpload from "./CoordinatorBulkUpload";
import TpUserMgtBreadCrumbs from "../Layout/TpUserMgtBreadCrumbs";

const TpCoordinators = () => {
  return (
    <Box sx={{ paddingTop: "80px" }}>
      <TpUserMgtBreadCrumbs />
      <TpUsersByType
        userType="coordinator"
        title="Tech Prep Coordinators"
        icon={faUserTie}
        iconColor="#2196f3"
        enableBulkDelete
        extraHeaderActions={(refetch) => (
          <CoordinatorBulkUpload onComplete={refetch} />
        )}
      />
    </Box>
  );
};

export default TpCoordinators;
